import _regeneratorRuntime from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import _inherits from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/inherits.js";
import _createSuper from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/createSuper.js";
import AvueSelectTemplateService from '@/service/AvueSelectTemplateService/AvueSelectTemplateService';
import { getDictionaryApi } from '@/api/apiHRManagement';
var DictionaryAvueSelectTemplateImpl = /*#__PURE__*/function (_AvueSelectTemplateSe) {
  _inherits(DictionaryAvueSelectTemplateImpl, _AvueSelectTemplateSe);
  var _super = _createSuper(DictionaryAvueSelectTemplateImpl);
  function DictionaryAvueSelectTemplateImpl() {
    _classCallCheck(this, DictionaryAvueSelectTemplateImpl);
    return _super.apply(this, arguments);
  }
  _createClass(DictionaryAvueSelectTemplateImpl, [{
    key: "abstractLabelCode",
    value: function abstractLabelCode() {
      return 'codeName';
    }
  }, {
    key: "abstractValueCode",
    value: function abstractValueCode() {
      return 'codeValue';
    }
  }, {
    key: "abstractQueryDictData",
    value: function () {
      var _abstractQueryDictData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(dictType, source) {
        var params, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  codeType: dictType,
                  source: source
                };
                _context.next = 3;
                return getDictionaryApi(params);
              case 3:
                response = _context.sent;
                return _context.abrupt("return", response);
              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      function abstractQueryDictData(_x, _x2) {
        return _abstractQueryDictData.apply(this, arguments);
      }
      return abstractQueryDictData;
    }()
  }]);
  return DictionaryAvueSelectTemplateImpl;
}(AvueSelectTemplateService);
export { DictionaryAvueSelectTemplateImpl as default };